function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_67806",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Subtraction_74",
  d: "M.495,19.952a.493.493,0,0,1-.41-.217.5.5,0,0,1-.031-.5l1.469-2.913a1.231,1.231,0,0,0-.046-1.2A9.97,9.97,0,0,1,9.9,0h.121a9.972,9.972,0,0,1,7.04,17.043,9.91,9.91,0,0,1-7.033,2.909H9.978a9.855,9.855,0,0,1-4.318-1,1.252,1.252,0,0,0-1.078-.013A12.193,12.193,0,0,1,.538,19.95ZM7.85,5.367a2.723,2.723,0,0,0-2,.857,3.2,3.2,0,0,0-.824,2.218,5.065,5.065,0,0,0,1.226,3.1,13.273,13.273,0,0,0,3.284,2.85,1.067,1.067,0,0,0,.468.2,1.093,1.093,0,0,0,.467-.2,13.225,13.225,0,0,0,3.287-2.85,5.065,5.065,0,0,0,1.224-3.1,3.205,3.205,0,0,0-.823-2.218,2.717,2.717,0,0,0-2-.857A2.4,2.4,0,0,0,10,6.714,2.378,2.378,0,0,0,7.85,5.367Z",
  transform: "translate(0)",
  fill: "currentColor"
}));

function SvgBubbleHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.952,
    viewBox: "0 0 20 19.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleHeart);
export default __webpack_public_path__ + "static/media/bubble-heart.c3881a7f.svg";
export { ForwardRef as ReactComponent };